export default     {
    prompt:"Background On/Off?",
    field:"backgroundState",
    type:"class",
    default:"off",
    options:[
        {value:"on",text:"On"},
        {value:"off",text:"Off"}
    ]
}